import React from 'react';
import ReactDOM from 'react-dom/client';
import "./styles/fonts.css";
import './index.css';
import reportWebVitals from './reportWebVitals';
import RouteSwitch from './RouterSwitch';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouteSwitch />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
